import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { projectActions } from '../../store';

export const CreateProjectDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [key, setKey] = useState('');
  const [description, setDescription] = useState('');

  const handleNameChange = (e) => {
    const val = e.target.value;
    setName(val);
    if (!key || key === generateKey(name)) {
      setKey(generateKey(val));
    }
  };

  const generateKey = (str) => {
    return (str || '')
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .slice(0, 4);
  };

  const handleSubmit = () => {
    dispatch(projectActions.createProject({ name, key, description }));
    setName('');
    setKey('');
    setDescription('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Create New Project</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Project Name"
          value={name}
          onChange={handleNameChange}
          margin="normal"
          required
          autoFocus
        />
        <TextField
          fullWidth
          label="Project Key"
          value={key}
          onChange={(e) => setKey(e.target.value.toUpperCase())}
          margin="normal"
          required
          helperText="A short identifier (e.g., PROJ, TASK)"
          inputProps={{ maxLength: 6 }}
        />
        <TextField
          fullWidth
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          margin="normal"
          multiline
          rows={3}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!name || !key}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Create Project
        </Button>
      </DialogActions>
    </Dialog>
  );
};
